export const BASE_URL =
    process.env.NODE_ENV === "development"
        ? "http://111.88.4.58:3330"
        : ""; // PRODUCTION URL
// : "http://164.92.173.118/staging/legends"; // Staging URL

// export const BASE_URL =
//   "https://062a-2407-aa80-15-8847-c999-7ab7-560c-ae3c.eu.ngrok.io"; // DEVELOPMENT URL
